import BaseCCatalogList from "./BaseCCatalogList";
import { ECatalogFilter } from "./ECatalogFilter";
import BaseMCatalogTemplate from "./BaseMCatalogTemplate";

export default abstract class BaseCCatalogListFilters {
  protected listController: BaseCCatalogList;

  protected constructor(listController: BaseCCatalogList) {
    this.listController = listController;
  }

  public abstract ApplyFilters(): void;

  /**
   * Filter the template list by the current options filter values
   * @param filter  The return value will the filtered list element without this specific one
   *                Useful to determine the counter of this filter
   * @constructor
   */
  public abstract FilterBy(filter?: ECatalogFilter): BaseMCatalogTemplate[];

  protected init(): void {
    $(".filters-reset").on("click", () => {
      this.resetFilters();
    });
    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get(ECatalogFilter.STUDIED_LANGUAGE);
    this.applyUrlFilters();
    this.ApplyFilters();
    if (!filter) {
      this.setDefaultLanguage();
    }
  }

  protected abstract resetFilters(): void;

  protected abstract setDefaultLanguage(): void;

  protected abstract applyUrlFilters(): void;
}
